exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".call-status-pills {\n  text-align: center;\n}\n.call-status-pills span {\n  width: 60px;\n  justify-content: center;\n  font-size: 2rem;\n}\n@media (max-width: 991px) {\n.call-status-pills span {\n    width: 60%;\n}\n}\n@media (max-width: 500px) {\n.call-status-pills span {\n    width: 100%;\n}\n}", ""]);

// exports
